import(/* webpackMode: "eager", webpackExports: ["Blocks","BuilderContext","Button","Columns","Content","Fragment","Image","Section","Symbol","Text","Video"] */ "/app/node_modules/@builder.io/sdk-react/lib/node/blocks-exports.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/node_modules/react-error-boundary/dist/react-error-boundary.esm.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/app/src/app/[locale]/_internal/ClientProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "/app/src/components/CookieBanner/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DarkModeWrapper"] */ "/app/src/components/DefaultLayout/DarkModeWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTMRunner"] */ "/app/src/components/DefaultLayout/GTMRunner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SoftAgeVerificationContent"] */ "/app/src/components/DefaultLayout/SoftAgeVerificationContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustPilot"] */ "/app/src/components/DefaultLayout/TrustPilot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorker"] */ "/app/src/components/ServiceWorkers/ServiceWorker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopBannersContainer"] */ "/app/src/components/TopBannersContainer/TopBannersContainer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/context/PageConfigContext/PageConfigContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/libs/builder/Content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/src/libs/i18n/Link.tsx");
